import { supabase } from '../supabase';

/**
 * KAN-200 Ship A — the company's OWN access level (server: `get_my_company_access`,
 * any member may call it). Admin/owner also get `next_level`, `next_step_on`
 * and `paused_until`; every other role gets `{level, reason}` only.
 * Fail-soft: any failure (or an unknown level) returns `null` and never
 * surfaces server text (KAN-590). The server is the boundary — this is UX.
 *
 * @returns {Promise<null | {
 *   level: 'full'|'grace'|'read_only'|'suspended',
 *   reason: string|null, nextLevel: string|null, nextStepOn: string|null, pausedUntil: string|null,
 * }>}
 */
export const ACCESS_LEVELS = Object.freeze(['full', 'grace', 'read_only', 'suspended']);

export async function getMyCompanyAccess() {
  try {
    const { data, error } = await supabase.rpc('get_my_company_access');
    if (error || !data || typeof data !== 'object') return null;
    if (!ACCESS_LEVELS.includes(data.level)) return null;
    return {
      level: data.level,
      reason: data.reason ?? null,
      nextLevel: data.next_level ?? null,
      nextStepOn: data.next_step_on ?? null,
      pausedUntil: data.paused_until ?? null,
    };
  } catch {
    return null;
  }
}
